// Offline-first storage for the Score Keeper.
// - Caches reference data (games/teams/players) so a game can be opened & refreshed offline.
// - Persists the full in-progress scoring state per game so a refresh/close never loses data.
// - Holds a single "pending" server action (latest stats save or finalize) to replay on reconnect.

const STATE_KEY = (id) => `sk_state_${id}`;
const REF_KEY = "sk_refdata";

const read = (k) => {
  try { return JSON.parse(localStorage.getItem(k) || "null"); } catch { return null; }
};
const write = (k, v) => {
  try { localStorage.setItem(k, JSON.stringify(v)); } catch { /* quota / private mode */ }
};

export function saveLocalState(gameId, snap) {
  if (!gameId) return;
  write(STATE_KEY(gameId), { ...snap, updatedAt: new Date().toISOString() });
}

export function loadLocalState(gameId) {
  return gameId ? read(STATE_KEY(gameId)) : null;
}

export function clearLocalState(gameId) {
  try { localStorage.removeItem(STATE_KEY(gameId)); } catch { /* noop */ }
}

export function patchLocalState(gameId, patch) {
  const cur = loadLocalState(gameId) || {};
  saveLocalState(gameId, { ...cur, ...patch });
}

export function cacheRefData(data) {
  write(REF_KEY, { ...data, cachedAt: Date.now() });
}

export function loadRefData() {
  return read(REF_KEY);
}

// Cache an image (e.g. team logo) as a base64 data URL, keyed by its source URL,
// so the emergency score sheet PDF can embed it even with no internet.
export function cacheImageDataUrl(srcUrl, dataUrl) {
  if (!srcUrl || !dataUrl) return;
  write(`sk_img_${srcUrl}`, dataUrl);
}

export function loadImageDataUrl(srcUrl) {
  return srcUrl ? read(`sk_img_${srcUrl}`) : null;
}
